import { render, staticRenderFns } from "./bulk-merge-conversations-modal.vue?vue&type=template&id=18520ba6&"
import script from "./bulk-merge-conversations-modal.vue?vue&type=script&lang=ts&"
export * from "./bulk-merge-conversations-modal.vue?vue&type=script&lang=ts&"
import style0 from "./bulk-merge-conversations-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports